import type { Fare } from '@/src/types/itinerary'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { useMemo } from 'react'

/**
 * Hook for extracting fare pricing values from selected fare and fare family
 * Handles logic for fare family vs regular fare selection
 */
const useFarePricingValues = (selectedFare: Fare, selectedFareFamily: Fare, fareFamilyEnabledOnReview: boolean) => {
    const fareValues = useMemo(() => {
        let {
            price,
            basePrice = 0,
            taxes = 0,
            convenienceFee = 0,
            discount,
            totalPremiumAmount = 0,
            fareMetaMessages,
            totalVat: faresVat = 0
        } = fareFamilyEnabledOnReview ? selectedFareFamily : selectedFare || {}

        let fareInsuranceTitle = fareMetaMessages?.[0]?.title || ''
        let fareInsuranceTitleWithVat = fareInsuranceTitle + ' (VAT)'
        let vatAmountOnPremium = selectedFare?.vatAmountOnPremium || 0
        let totalPremiumAmountWithVat = totalPremiumAmount + vatAmountOnPremium

        if (fareFamilyEnabledOnReview && !isEmpty(selectedFare)) {
            fareInsuranceTitle = selectedFare?.fareMetaMessages?.[0]?.title || ''
            fareInsuranceTitleWithVat = fareInsuranceTitle + ' (VAT)'
            totalPremiumAmount = selectedFare.totalPremiumAmount
            vatAmountOnPremium = selectedFare?.vatAmountOnPremium || 0
            totalPremiumAmountWithVat = totalPremiumAmount + vatAmountOnPremium
        }

        return {
            price,
            basePrice,
            taxes,
            convenienceFee,
            discount,
            totalVat: faresVat,
            fareInsuranceTitle,
            fareInsuranceTitleWithVat,
            totalPremiumAmount,
            totalPremiumAmountWithVat
        }
    }, [selectedFare, selectedFareFamily, fareFamilyEnabledOnReview])

    return {
        farePrice: fareValues.price || 0,
        basePrice: fareValues.basePrice,
        taxes: fareValues.taxes,
        faresVat: fareValues.totalVat,
        convenienceFee: fareValues.convenienceFee,
        totalPremiumAmount: fareValues.totalPremiumAmount,
        totalPremiumAmountWithVat: fareValues.totalPremiumAmountWithVat,
        fareInsuranceTitle: fareValues.fareInsuranceTitle,
        fareInsuranceTitleWithVat: fareValues.fareInsuranceTitleWithVat
    }
}

export default useFarePricingValues
